import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
//   justify-content: center;
//   align-items: center;
  height: 100vh;
  margin: 20px;
  flex-direction: column; 
  max-width: 1142px;
`;

export const UploadBox = styled.div`
  width: 1142px;
  height: 427px;
  border: 1px dashed rgba(56, 78, 183, 0.3); 
  background-color: #f8f8ff;
  border-radius: 4px; 
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
`;

export const IconContainer = styled.div`
  margin-bottom: 10px;
`;

export const InstructionText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  text-align: center;
`;

export const SelectButton = styled.label`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #483ea8;
  text-align: center;
  cursor: pointer;
`;

export const FileName = styled.p`
  margin-top: 10px;
  font-size: 14px;
  color: #333;
`;

export const SupportFormats = styled.p`
  font-family: 'Mulish', sans-serif;
  font-size: 12px;
  color: #676767;
  margin-top: 10px;
  text-align: center;
`;


export const UploadButton = styled.div`
  margin-top: 45px; 
  display: grid;
  justify-items: end;
`;

export const ProgressContainer = styled.div`
  width: 1142px;
  margin-top: 20px;
`;

export const ErrorText = styled.p`
  color: #e74c3c;
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
  text-align: center;
`;

export const ProgressBar = styled.div`
  height: 10px;
  background-color: #f1f1f1;
  border-radius: 5px;
  transition: width 0.3s ease;
`;

export const AlertMessage = styled.p`
  margin-top: 10px;
  font-size: 14px;
  color: #f26a1d;
  text-align: center;
`;

export const InstructionSubText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  margin-bottom: 10px;
  color: #676767;
`;

export const ErrorContainer = styled.div`
  margin-top: 20px;
  background-color: #fce7f1;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
`;

export const ErrorAlert = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #e02e1a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #e02e1a;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`;

export const TaskStatusContainer = styled.div`
  margin-top: 24px;
  padding: 16px;
  border-radius: 8px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  width: 40%;
`;

export const TaskStatusHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const TaskStatusTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

export const TaskStatusDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TaskStatusRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TaskStatusLabel = styled.span`
  font-size: 14px;
  color: #666;
`;

export const TaskStatusValue = styled.span`
  font-size: 14px;
  font-weight: ${props => props.status === 'FAILED' ? '600' : '500'};
  color: ${props => {
    switch (props.status) {
      case 'SUCCESS': return '#4CAF50';
      case 'FAILED': return '#F44336';
      case 'STARTED': return '#2196F3';
      case 'PENDING': return '#FF9800';
      default: return '#333';
    }
  }};
`;
